var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"special-box",class:_vm.colorClass},[_c('tag',{staticClass:"special-box__tag",attrs:{"color":_vm.color}},[_vm._t("tag")],2),_vm._v(" "),_c('p',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }